import styled from 'styled-components';

const TabList = styled.ul`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  margin: 0;
  padding: 0;
  border-bottom: 1px solid #ccc;
`;

export default TabList;



// WEBPACK FOOTER //
// ./src/components/atoms/tabs/TabList.js